import type { ResolverRoute } from "./router-resolver-gate.type";

import { useLocation } from "react-router";

import { getResolverLinkPath } from "./router-resolver-gate.helper";

export const useGetResolverPath = (routes: ResolverRoute[]) => {
  const location = useLocation();

  const resolverPath = getResolverLinkPath({
    routes,
    pathname: location.pathname,
    search: location.search,
  });

  const redirectTo = resolverPath ? resolverPath + location.hash : undefined;

  return { redirectTo };
};
